/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  homeDiscover: {
    id: 'home.discover',
    defaultMessage: 'Stap 1: Ontdek je eigen motiverende stijl'
  },
  homeAnalyse: {
    id: 'home.analyse',
    defaultMessage: 'Stap 2: Analyseer je eigen les'
  },
  homeTips: {
    id: 'home.tips',
    defaultMessage: 'Stap 3: Bekijk concrete motiverende strategieën'
  }
});



// WEBPACK FOOTER //
// ./src/containers/static/messages.js